//permissions
export default {
    DOMAIN_CREATE: 'domains:create',
    DEFINITION_CREATE: 'definitions:create',
    INSTANCES_UPDATE: 'instances:update',
    VIEW_SHARE: "view:share"
};
